import { createGlobalStyle } from 'styled-components';

const base = './fonts/';

const regular = `${base}Ubuntu-Regular.ttf`;
const bold = `${base}Ubuntu-Bold.ttf`;
const boldItalic = `${base}Ubuntu-BoldItalic.ttf`;
const italic = `${base}Ubuntu-Italic.ttf`;
const light = `${base}Ubuntu-Light.ttf`;
const lightItalic = `${base}Ubuntu-LightItalic.ttf`;
const medium = `${base}Ubuntu-Medium.ttf`;
const mediumItalic = `${base}Ubuntu-MediumItalic.ttf`;

export default createGlobalStyle`
    @font-face {
        font-family: 'Ubuntu', 'Times New Roman', Times, serif;
        src: 
            url(${regular}), 
            url(${bold}), 
            url(${boldItalic}), 
            url(${italic}), 
            url(${light}), 
            url(${lightItalic}), 
            url(${medium}), 
            url(${mediumItalic});
    }

    #s-gdpr * {
        box-sizing: border-box !important;
        font-family: 'Ubuntu', sans-serif !important;
    }

    .s-gdpr__effect {
        opacity: 0;
    }

    .s-gdpr__effect-enter {
        opacity: 0;
        transition: all 200ms;
        transform: translateY(40px);
    }

    .s-gdpr__effect-enter-active {
        opacity: 1;
        transform: translateY(0px);
    }

    .s-gdpr__effect-exit {
        opacity: 1;
    }

    .s-gdpr__effect-exit-active {
        opacity: 0;
        transition: all 200ms;
    }
`;
